export default "__VITE_ASSET__BZaC7wik__"